<template>
  <b-card>
    <div slot="header">
      <i
        class="fa fa-list-ul"
        aria-hidden="true"
      ></i>
      {{text.oneAppUsers}}
    </div>
    <b-row>
      <b-col sm="12">
        <b-form-input
          type="search"
          v-model="keyword"
          :placeholder="text.enterKeyword"
          v-on:keyup.enter="getUsers"
        ></b-form-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <alert-fail :show="isError"> {{ errorMessage }} </alert-fail>
        <b-table
          stacked="sm"
          :busy="isBusy"
          :current-page="currentPage"
          :per-page="numberPerPage"
          class="table-app"
          tbody-class="tbody"
          hover
          thead-tr-class="thead-app"
          selectedVariant="single"
          :filter="keyword"
          :fields="fields"
          :items="userItemsProvider"
          @row-clicked='getUserProfile'
        >
          <div
            slot="table-busy"
            class="text-center text-dark my-2"
          >
            <b-spinner
              variant="dark"
              class="align-middle"
            ></b-spinner>
            <strong>{{text.loading}}</strong>
          </div>
        </b-table>
        <hr />
        <b-row>
          <b-col>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="numberPerPage"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import AlertFail from '@/components/alert/AlertFail';
import { dateToStringWithTimeFull } from '@/assets/utils/time.js';
import { currentUser } from '@/assets/utils/user';
import MqdcOneClient from '@/models/mqdc-one-client';
import { textUserProfiles } from '../../assets/utils/language';

export default {
  data () {
    return {
      isBusy: false,
      numberPerPage: 10,
      fields: [],
      usersList: [],
      isError: false,
      errorMessage: '',
      currentPage: 1,
      totalRows: 1,
      authenticated: false,
      keyword: '',
      keywordText: '',
      mqdcOneClient: {},
      text: {}
    };
  },
  mounted () {
    this.mqdcOneClient = new MqdcOneClient(this.axios);
    this.text = textUserProfiles(this.$language);
    this.refreshTableField();
  },
  methods: {
    /// Items Provider for b-table
    async userItemsProvider (ctx) {
      try {
        const permittedProjects = currentUser().permission.filter(p => {
          return (p.split('project-').length > 1);
        }).map(u => u.substring(8, u.length).toUpperCase());

        const projectCodeParam = permittedProjects.includes('*') ? '&projectCode=all' : '&projectCode=' + permittedProjects;
        let getUrl = process.env.VUE_APP_URL_MQDCONE_API + '/mqdc-one/users?currentPage=' + ctx.currentPage + '&perPage=' +
          ctx.perPage + '&keyword=' + ctx.filter + projectCodeParam;

        const promise = this.mqdcOneClient.getAxios().then(axios => {
          return axios.get(
            getUrl
          )
          ;
        });

        return promise.then(data => {
          const users = data.data.data;

          const userItems = [];
          for (const user of users) {
            let userRaw = {
              id: user.id,
              email: user.email,
              firstName: user.firstName,
              lastName: user.lastName,
              status: 'enable' === user.status ? 'Active' : 'Not Active',
              verifiedAccount: user.verifiedAt !== null ? this.toLocalDateTime(user.verifiedAt.timestamp) : 'Not Verified', // convert utc time to localtime with new Date()
              createdAt: user.createdAt !== null ? this.toLocalDateTime(user.createdAt.timestamp) : null,
              updatedAt: user.updatedAt !== null ? this.toLocalDateTime(user.updatedAt.timestamp) : null
            };
            userItems.push(userRaw);
          }
          this.totalRows = data.data.pagination.total;
          // Must return an array of items or an empty array if an error occurred
          return userItems || [];
        });
      } catch (err) {
        return [];
      }
    },
    async getUserProfile (row) {
      this.$router.push({ name: 'one_app_profiles-profile', params: { id: row.id } });
    },
    toLocalDateTime (dt) {
      return dateToStringWithTimeFull(new Date(dt * 1000));
    },
    errorHandler (error) {
      console.log(error);
      this.errorMessage = error.message;
      if (error.message) {
        this.errorMessage = error.message;
        this.isError = true;
      }
    },
    refreshTableField () {
      this.fields = [ { key: 'email', label: this.text.email },
        { key: 'firstName', label: this.text.firstName },
        { key: 'lastName', label: this.text.lastName },
        { key: 'verifiedAccount', label: this.text.verifiedAccount },
        { key: 'status', label: this.text.status },
        { key: 'createdAt', label: this.text.createdAt },
        { key: 'updatedAt', label: this.text.updatedAt }];
    }
  },
  components: {
    AlertFail
  },
  created () {
    document.title = 'One App: User Profiles';
  },
  watch: {
    $language: function () {
      this.text = textUserProfiles(this.$language);
      this.refreshTableField();
    }
  }
};
</script>
